import React from "react";
import Blog_58 from "../component/Blog_58";

function Blog_58_container() {
  return <Blog_58 />;
}

export default Blog_58_container;
